module.exports = __webpack_public_path__ + "img/ADDRESS.10a38e60.svg";